import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import moment from 'moment';
import { TaskType } from '@compumark/analyst-selection-tool-client';

@Component({
  selector: 'app-time-left-renderer',
  standalone: false,
  templateUrl: './time-left-renderer.component.html',
  styleUrls: ['./time-left-renderer.component.scss'],
})
export class TimeLeftRendererComponent implements ICellRendererAngularComp {
  private static readonly MILLISECONDS_IN_AN_HOUR = 60 * 60 * 1000;

  deliveryDate!: moment.Moment;
  currentDate!: moment.Moment;
  turnaroundTime!: string;
  isArchiveTask = false;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.deliveryDate = moment(params.data.deliveryDate);
    this.turnaroundTime = params.data.turnaroundTime;
    this.currentDate = moment();
    this.isArchiveTask = params.data.taskType === TaskType.ARCHIVED;
    setInterval(() => (this.currentDate = moment()), 1000);
  }

  getTimeLeft(): string {
    const numberOfDaysLeft = this.getNumberOfDaysLeft();
    const millisecondsLeft = this.getMillisecondsLeft();
    if (numberOfDaysLeft < 0 || millisecondsLeft < 0) {
      return 'Overdue';
    } else if (numberOfDaysLeft < 1) {
      return moment
        .utc(moment.duration(millisecondsLeft).asMilliseconds())
        .format('HH:mm');
    } else if (numberOfDaysLeft === 1) {
      return '1 day+';
    } else {
      return numberOfDaysLeft + ' days+';
    }
  }

  private getMillisecondsLeft(): number {
    return this.deliveryDate.diff(this.currentDate);
  }

  private getNumberOfDaysLeft(): number {
    return this.deliveryDate.diff(this.currentDate, 'days');
  }

  getTimeLeftClass(): string {
    const millisecondsLeft = this.getMillisecondsLeft();
    if (
      millisecondsLeft <=
      2 * TimeLeftRendererComponent.MILLISECONDS_IN_AN_HOUR
    ) {
      return 'warning';
    } else {
      return '';
    }
  }

  refresh(): boolean {
    return false;
  }
}
